/* eslint-disable */
import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  IconButton,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import imageCompression from 'browser-image-compression';
import { useLocation, useNavigate } from 'react-router-dom';
import InfoTooltip from '../InfoTooltip';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import {
  createCategory,
  createDoorList,
  deleteUploads,
  getAllLuggage,
  getBnbList,
  updateDoorlist,
  updatePrivateParking,
  uploadFile,
} from '../../helper/backend_helper';
import appConfig from '../../config';

const UpdatePrivateParking = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location?.state?.userData;
  const [delImage, setDelImage] = useState([]);
  const [formData, setFormData] = useState({ profileImages: [] });
  const imagesData = [...(userData?.image || []), ...(formData?.profileImages || [])];
  // console.log(imagesData);
  const filteredImages = imagesData.filter(
    (img) => !delImage.includes(img) // adjust this if img is an object
  );

  const [bnb, setBnB] = useState(userData?.bnb);
  const [description, setDescription] = useState(userData?.description);
  const [loading, setLoading] = useState(false);
  const [italianDescription, setItalianDescription] = useState(userData?.italianDescription);
  const [images, setImages] = useState(userData?.image || []);
  const handleFileChange = (e) => {
    const { files } = e.target;
    const selectedFiles = Array.from(files);

    setFormData((prevState) => ({
      ...prevState,
      profileImages: [...prevState.profileImages, ...selectedFiles],
    }));
  };

  const handleDeleteImage = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      profileImages: prevData.profileImages.filter((_, i) => i !== index),
    }));
  };

  // Called when deleting an existing image
  const existingImageDel = (img) => {
    setDelImage((prevImages) => [...prevImages, img]);
  };

  const [users, setUsers] = useState([]);
  // console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.BnBShortName?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      if (bnb.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'BnB Name is required',
        });
        setLoading(false);
        return;
      }

      if (!description) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Description is required',
        });
        setLoading(false);
        return;
      }

      if (!italianDescription) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Italian Description is required',
        });
        setLoading(false);
        return;
      }
      // Prepare headers for multipart form data
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      console.log(delImage);
      // await Promise.all(
      //   delImage?.map(async (image) => {
      //     const data = {
      //       filename: image,
      //     };
      //     console.log(data)
      //       const res  =   await deleteUploads(data, headers); // Delete each image
      //       console.log(res)
      //   })
      // );

      const uploadedImageNames = [];

      for (let i = 0; i < filteredImages.length; i++) {
        const originalFile = filteredImages[i];

        // ✅ If the type is string, it's already uploaded, so just push it directly
        if (typeof originalFile === 'string') {
          console.log(`Image ${i + 1} is an existing image string:`, originalFile);
          uploadedImageNames.push(originalFile);
          continue; // Skip to the next item
        }

        // ✅ Else, process as a new file (File or Blob object)
        console.log(`Original file size (${i + 1}):`, (originalFile.size / 1024).toFixed(2), 'KB');

        const options = {
          maxSizeMB: 0.3,
          maxWidthOrHeight: 800,
          useWebWorker: true,
          initialQuality: 0.6,
        };

        try {
          const compressedFile = await imageCompression(originalFile, options);

          console.log(`Compressed file size (${i + 1}):`, (compressedFile.size / 1024).toFixed(2), 'KB');

          const data = new FormData();
          data.append('file', compressedFile);

          const imageUploadResponse = await uploadFile(data, headers);

          if (imageUploadResponse.status !== 200) {
            throw new Error(`Image ${i + 1} upload failed`);
          }

          const uploadedFileName = imageUploadResponse?.data?.data?.fileName;
          uploadedImageNames.push(uploadedFileName);
        } catch (error) {
          console.error(`Error processing image ${i + 1}:`, error);
        }
      }

      console.log('Final uploaded image names:', uploadedImageNames);

      // Build the Categorydata object
      const Categorydata = {
        image: uploadedImageNames,
        description,
        bnb,
        italianDescription,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await updatePrivateParking(userData?._id, Categorydata, Categoryheaders);

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Updated successfully',
      });
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Private Parking </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Update Private Parking</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
            <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>BnB <InfoTooltip title="Properties that this private parking spot is reserved for; only their guests will see it." /></FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                multiple
                value={bnb} // This will be an array
                onChange={(e) => setBnB(e.target.value)}
                renderValue={(selected) => selected.join(', ')} // Render selected values as a comma-separated string
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    <Checkbox checked={bnb.indexOf(user.BnBShortName) > -1} />
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 2 }}>
            <FormLabel sx={{ mb: 1 }}>Description <InfoTooltip title="English details about this private parking, e.g. where it is and how guests access it." /></FormLabel>
            <TextField
              multiline
              rows={4}
              label="Enter Description"
              id="outlined-size-small"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Stack>

          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 2 }}>
            <FormLabel sx={{ mb: 1 }}>Italian Description <InfoTooltip title="Italian version of the private parking details, shown to guests using the app in Italian." /></FormLabel>
            <TextField
              multiline
              rows={4}
              label="Enter Italian Description"
              id="outlined-size-small"
              value={italianDescription}
              onChange={(e) => setItalianDescription(e.target.value)}
            />
          </Stack>

          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 2,
              marginTop: 2,
            }}
          >
            <Stack direction="row" spacing={2} flexWrap="wrap">
              {filteredImages.map((item, index) => {
                const isNewUpload = item instanceof File;

                return (
                  <Box key={index} sx={{ position: 'relative', width: 150, height: 150 }}>
                    <img
                      src={
                        isNewUpload
                          ? URL.createObjectURL(item) // New upload preview
                          : `${appConfig.FILE_URL}${item}` // Existing image URL
                      }
                      alt={`image-${index}`}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: 10,
                      }}
                    />

                    <IconButton
                      size="small"
                      // onClick={() => {
                      //   if (isNewUpload) {
                      //     // Calculate index in profileImages
                      //     const profileImagesIndex = index - (userData?.image?.length || 0);
                      //     handleDeleteImage(profileImagesIndex);
                      //   } else {
                      //     existingImageDel(item, index);
                      //   }
                      // }}
                      onClick={() => {
                        if (item instanceof File) {
                          setFormData((prevData) => ({
                            ...prevData,
                            profileImages: prevData.profileImages.filter((img) => img !== item),
                          }));
                        } else {
                          existingImageDel(item);
                        }
                      }}
                      sx={{
                        position: 'absolute',
                        top: 5,
                        right: 5,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        color: 'white',
                        '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' },
                      }}
                    >
                      X {/* Replace with CloseIcon if you want */}
                    </IconButton>
                  </Box>
                );
              })}
            </Stack>

            <Button
              sx={{
                width: 170,
                color: '#1E3A5F',
                borderColor: '#1E3A5F',
                '&:hover': {
                  borderColor: '#1E3A5F',
                  boxShadow: 'none',
                },
              }}
              component="label"
              variant="outlined"
              size="medium"
              startIcon={<SlCloudUpload />}
            >
              upload Image
              <input
                multiple
                type="file"
                accept="image/*"
                name="profileImage"
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
            </Button>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default UpdatePrivateParking;
